import { render, staticRenderFns } from "./ProductPackaging.vue?vue&type=template&id=4d3e2eca&scoped=true&"
import script from "./ProductPackaging.vue?vue&type=script&lang=js&"
export * from "./ProductPackaging.vue?vue&type=script&lang=js&"
import style0 from "./ProductPackaging.vue?vue&type=style&index=0&id=4d3e2eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3e2eca",
  null
  
)

export default component.exports